var map = {
	"./de": 737,
	"./de.js": 737,
	"./en": 9462,
	"./en.js": 9462,
	"./es": 6835,
	"./es.js": 6835,
	"./fr": 235,
	"./fr.js": 235,
	"./index-map": 5190,
	"./index-map.ts": 5190,
	"./pt": 2452,
	"./pt.js": 2452,
	"./ru": 3844,
	"./ru.js": 3844,
	"./supported-languages": 6394,
	"./supported-languages.ts": 6394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;